import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=4a539e96&scoped=true"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=4a539e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a539e96",
  null
  
)

export default component.exports